/* eslint-disable camelcase */
import { useHistory } from 'react-router-dom';

// Context
import useAuth from '@Auth/userAuth';

// Contants
import { LocalStoragePlanets } from '@Helpers/constants';

// Services
import { singUpUser, login, createProject } from '@Service/entries';

export const useEventsRegister = () => {
  const { contextValue, setLoading } = useAuth();
  const history = useHistory();

  const handleRegister = async (data) => {
    try {
      const singup = await singUpUser(data);
      if (singup.code === 0) {
        const logIn = await login(data);
        const token = logIn.data;
        contextValue.login(token.token);

        setTimeout(async () => {
          const questions = JSON.parse(localStorage.getItem(LocalStoragePlanets.LUNA));
          await createProject(questions);
          history.push('/');
          setLoading(false);
        }, 3000);

        setTimeout(async () => {
          location.reload();
        }, 4000);
        
      } else if (singup.code < 0) {
        if (singup.messageError === 'The email has already been taken.') {
          setLoading(false);
          return 'El email ya esta registrado';
        }
        setLoading(false);
        return 'Ocurrio un error al registrar usuario';
      }
    } catch (error) {
      setLoading(false);
      return 'Ocurrio un error al registrar usuario';
    }
  };
  return {
    handleRegister,
  };
};
